import type React from "react";

export interface CalculationEntry {
  id: string;
  name: string;
  line: string;
  supplierName: string;
  planningYear: number;
  keyAccountManager: string;
  status: CalculationStatus;
  lastEditedAt: string;
  costCategories: string[];
}

export interface DeleteCalculationCandidate {
  id: string;
  name: string;
}

export type CalculationStatus = "DRAFT" | "COMPLETE";

export interface CalculationFilters {
  name: string;
  lines: string[];
  supplierIds: string[];
  kamNames: string[];
  planningYear: number | null;
  status: CalculationStatus | null;
}

export const hasActiveFilters = (f: CalculationFilters): boolean =>
  f.name.trim().length > 0 ||
  f.lines.length > 0 ||
  f.supplierIds.length > 0 ||
  f.kamNames.length > 0 ||
  f.planningYear !== null ||
  f.status !== null;

export interface SuppliersGate {
  loading: boolean;
  count: number;
}

export const computeAddDisabled = (gate: SuppliersGate): boolean => {
  if (gate.loading) return true;
  return gate.count === 0;
};

export const computeAddDisabledReason = (gate: SuppliersGate): string | null =>
  !gate.loading && gate.count === 0 ? "No suppliers configured" : null;

export interface CalculationInputListProps {
  entries: CalculationEntry[];
  pagination?: CalculationPaginationProps;
  deleteTargetRef?: React.RefObject<HTMLElement>;
  onOpen: (id: string) => void;
  onCopy: (id: string) => void;
  onDelete: (candidate: DeleteCalculationCandidate) => void;
}

export interface CalculationPaginationProps {
  pageSize: number;
  pageSizeOptions: number[];
  totalElements: number;
  displayPage: number;
  displayTotalPages: number;
  navigationDisabled: boolean;
  canGoPrevious: boolean;
  canGoNext: boolean;
  onPageSizeChange: (size: number) => void;
  onPageSelect: (page: number) => void;
  onPreviousPage: () => void;
  onNextPage: () => void;
}
